(ns minorodata.components.file-ingest.column-select
  (:require [applied-science.js-interop :as j]
            [clojure.string :as cstr]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.file-ingest.utils :as fi.utils]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.fields :refer [input]]
            [ui.stepper :as stepper]
            [ui.table :refer [table tbody td th thead tr]]
            [ui.typography :as typography]))


(defn validate-set-column [suggested-headers invalid-headers new-value idx]
  (let [previous-value (get @suggested-headers idx)
        changed?       (not= previous-value new-value)]
    (when changed?
      (let [[valid? message] (fi.utils/valid-header? @suggested-headers new-value)]
        (swap! suggested-headers assoc idx (cstr/lower-case new-value))
        (if valid?
          (swap! invalid-headers dissoc idx)
          (swap! invalid-headers assoc idx message))))))

(defn column-select-render [{:keys [table-data suggested-headers invalid-headers has-invalid-headers set-column]}]
  [:<>
   [card
    [:div {:class "text-center my-6"}
     [typography/p {:class "leading-6"}
      "Thanks, now let's check the columns names, we need to ensure they're database friendly." [:br]
      "You can edit your suggestions if you wish. Any edits must be short, memorable and with no duplicates."]]

    [table
     [thead
      [tr
       [th {:align "center"}
        "Given header"]
       [th {:align "center"}
        "Suggested header"]]]

     [tbody
      (doall
       (for [[i [given proposed]] (map-indexed vector table-data)
             :let [message (get invalid-headers i)]]
         ^{:key (:id given)}
         [tr
          [td {:align "center"}
           (:name given)]

          [td {:align "center"}
           [:div {:class "max-w-md"}
            [input {:default-value proposed
                    :error         (some? message)
                    :helper        (when (some? message) message)
                    :input-props   {:data-cy :column-select__header-input}
                    :on-blur       (fn [e]
                                     (let [value (j/get-in e [:target :value])]
                                       (set-column value i)))}]]]]))]]]

   [stepper/stepper-footer {:class "border-t-0"}
    [button {:data-cy  :column-select__submit
             :disabled has-invalid-headers
             :on-click #(do (dispatch [:ingest-selected-columns/delete])
                            (dispatch [:file-ingest.events/set-selected-columns suggested-headers]))}
     "Proceed"]]])


(defn column-select []
  (let [declared-headers    (re-posh/subscribe [:file-ingest.subs/declared-headers])
        *suggested-headers* (reagent/atom (->> @declared-headers
                                               (map :name)
                                               fi.utils/suggest-headers))
        *invalid-headers*   (reagent/atom {})]
    (fn []
      (let [suggested-headers   @*suggested-headers*
            invalid-headers     @*invalid-headers*
            set-column          (partial validate-set-column *suggested-headers* *invalid-headers*)
            has-invalid-headers (-> invalid-headers keys count (> 0))
            table-data          (->> (interleave @declared-headers suggested-headers)
                                     (partition 2))]
        [column-select-render
         {:table-data          table-data
          :set-column          set-column
          :suggested-headers   suggested-headers
          :invalid-headers     invalid-headers
          :has-invalid-headers has-invalid-headers}]))))
